import React from 'react';

/**
 * エラー
 */
export default function ErrorContainer({
  isValid = false,
  isWarning = false,
  isError = false,
  isTextArea = false,
  children,
}: {
  isValid?: boolean,
  isWarning?: boolean,
  isError?: boolean,
  isTextArea?: boolean,
  children: React.ReactNode,
}) {
  let className = '';
  if (isError) {
    className = 'form__error';
  }
  if (isWarning) {
    className = 'form__warning';
  }
  if (isValid) {
    if (isTextArea) {
      className = 'form__valid form__valid_textarea';
    } else {
      className = 'form__valid';
    }
  }
  return (
    <span className={className}>
      {children}
    </span>
  );
}
